import { render, staticRenderFns } from "./gl-reporting-group-1.vue?vue&type=template&id=5966831c&"
import script from "./gl-reporting-group-1.vue?vue&type=script&lang=js&"
export * from "./gl-reporting-group-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports